import { useEffect, useState } from "react";

/**
 * Triggers initial reservations fetch when the user id changes.
 */
export default function useInitialReservationsOnUserChange(
  userId: string | undefined,
  fetchInitialReservations: () => Promise<void>,
) {
  const [prevUserId, setPrevUserId] = useState<string | undefined>(undefined);

  useEffect(() => {
    if (userId && userId !== prevUserId) {
      fetchInitialReservations();
    }
  }, [userId, prevUserId, fetchInitialReservations]);

  useEffect(() => {
    if (userId !== prevUserId) setPrevUserId(userId);
  }, [userId, prevUserId]);
}
